import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[appConfirm]',
  standalone: true
})
export class ConfirmDirective {
  confirm = false;
  initialText = null;

  constructor(private el: ElementRef) {
    this.el.nativeElement.addEventListener('click', (event: any) => {
      if (this.confirm) {
        return;
      }

      const element = this.el.nativeElement;

      event.stopPropagation();

      this.confirm = true;
      this.initialText = element.innerHTML;

      element.innerHTML = 'Confirm?';
      element.classList.add('confirm');
    }, true)
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: PointerEvent) {
    const element = this.el.nativeElement;

    if (this.confirm) {
      this.confirm = false;
      element.innerHTML = this.initialText;
      element.classList.remove('confirm');
      this.initialText = null;
    }
  }
}
